module.exports = __webpack_public_path__ + "img/rujia.06f8df74.png";